import { render, staticRenderFns } from "./country-codes.vue?vue&type=template&id=2ea4be40"
import script from "./country-codes.vue?vue&type=script&lang=js"
export * from "./country-codes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports